import request from "axios";

/**
 * 获取订单分配明细列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export const getOrderAllocationList = (params) => {
  return request({
    url: "/lebo-report/financial/incomeOrderDetail/page",
    method: "get",
    params
  });
};

/**
 * 导出订单分配明细列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export const exportOrderAllocationList = (params) => {
  return request({
    url: "/lebo-report/financial/incomeOrderDetail/exportExcel",
    method: "get",
    params,
    responseType: 'blob',
    timeout: 300000  // 调整为5分钟，保证大数据量导出成功
  });
};

/**
 * 查询系统字典中的业务类型
 * @returns {Promise}
 */
export const getBusinessTypeOptions = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=order_business_type",
    method: "get"
  });
};

/**
 * 查询系统字典中的支付方式
 * @returns {Promise}
 */
export const getPaymentMethodOptions = () => {
  return request({
    url: "/lebo-system/dict/dictionary?code=pay_type_desc",
    method: "get"
  });
};

/**
 * 查询系统字典中的购买来源
 * @returns {Promise}
 */
export const getPurchaseSourceOptions = () => {
  return request({
    url: "/lebo-system/dict-biz/list?code=client_types",
    method: "get"
  });
};

/**
 * 查询系统字典中的会员类型
 * @returns {Promise}
 */
export const getMemberTypeOptions = () => {
  return request({
    url: "/lebo-member/web/member/type/dict",
    method: "get",
    params: {
      code: "memberRightsItem"
    }
  });
};

/**
 * 查询乐播云中的会员类型
 * @returns {Promise}
 */
export const getLeboMemberTypeOptions = () => {
  return request({
    url: "/lebo-report/member-platform/member/onLineType/queryAllServerTypeList",
    method: "get"
  });
};

/**
 * 查询乐播云中的商品类型
 * @returns {Promise}
 */
export const getLeboGoodsTypeOptions = () => {
  return request({
    url: "/lebo-report/member-platform/member/onLinePrice/queryAllGoodsList",
    method: "get"
  });
};

/**
 * 运营人员触发跑批 - 重跑收入/成本确认数据
 * @param {Object} params
 * @param {String} params.startMonth 开始月份，格式 yyyyMM
 * @param {String} params.endMonth 结束月份，格式 yyyyMM
 * @param {String} [params.orderId] 特定订单ID（可选）
 * @returns {Promise}
 */
export const runForOperation = (params) => {
  return request({
    url: "/lebo-report/financial/incomeOrderDetail/runForOperation",
    method: "get",
    params
  });
};

/**
 * 查询最近30天内统计任务的执行历史
 * @returns {Promise}
 */
export const getTaskStatus = () => {
  return request({
    url: "/lebo-report/financial/incomeOrderDetail/taskStatus",
    method: "get"
  });
};